<footer id="footer" class="footer">
    <div class="copyright">{{lang.Version}} IB:{{version}} {{build}}  © 2025:
      <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank"> {{lang.The_GroupBenefitz_Platform_Inc}}</a></div>
 </footer>
 <a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
